enum MimeType_2 {
	Png = 'image/png',
	Jpeg = 'image/jpeg',
	WebP = 'image/webp',
	Tga = 'image/x-tga',
	Mp4 = 'video/mp4',
	QuickTime = 'video/quicktime',
	Binary = 'application/octet-stream',
	Pdf = 'application/pdf',
	Zip = 'application/zip',
}

export { MimeType_2 as MimeType };
